module.exports = __webpack_public_path__ + "img/float-btn-sports.481812e4.svg";